import React from "react";

// Technical illustrations share the reactor's fine, light-on-dark line language.
const OrchardTree = ({ x, y, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <path d="M-3 0 -2-25 -11-37 M3 0 3-26 12-39 M0-24-1-45 M-2-29-13-29 M3-32 16-33" />
    <path d="M-15-27C-30-27-30-43-23-46-32-60-19-72-9-68-4-81 13-79 17-68 31-70 35-56 29-50 40-39 29-25 16-28 11-20-6-19-15-27Z" />
    <path d="M-23-46-14-48-17-57 M-9-68-6-58 1-55 M17-68 13-56 20-52 M29-50 19-44 M-15-27-12-37 M16-28 13-39" opacity=".6" />
    <path d="M-5 2 1 4 8 1 M-10 5 0 8 13 4" opacity=".5" />
  </g>
);

export const PlantationDrawing = ({ testId }) => (
  <svg viewBox="0 0 440 205" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" role="img" aria-label="Plantación de árboles frutales: biochar incorporado al suelo junto a las raíces" data-testid={testId}>
    <path d="M24 117 269 61 420 111 176 176Z M24 117V140L176 199 420 134V111 M176 176V199" opacity=".65" />
    <path d="M65 132 311 74 M111 151 357 92 M86 104 239 160 M167 86 316 141 M245 68 395 119" opacity=".2" />
    <OrchardTree x={169} y={92} scale={.61} />
    <OrchardTree x={254} y={72} scale={.56} />
    <OrchardTree x={322} y={96} scale={.64} />
    <OrchardTree x={243} y={120} scale={.79} />
    <OrchardTree x={161} y={144} scale={.91} />
    <OrchardTree x={86} y={116} scale={.77} />
    <g stroke="var(--green-light)">
      <path d="M48 137 174 184 394 124" strokeDasharray="1 7" strokeWidth="3" />
      <path d="M162 147 160 166 150 175 M160 156 147 158 139 163 M160 162 174 164 183 174 M245 122 244 140 230 150 M244 133 255 137 265 147" />
      <path d="M25 18H65V46L58 55H32L25 46Z M25 24H65 M34 32 40 40 45 34 53 41 59 32" />
      <path d="M45 61V77Q45 92 58 96L69 100" strokeDasharray="3 5" className="flow-line" />
      <path d="M62 93 70 100 59 101" />
      <path d="M57 110 59 113 M64 105 66 108 M66 116 68 119 M74 111 76 114 M77 122 79 125" strokeWidth="2.5" />
    </g>
    <path d="M32 130 35 136 M49 139 54 145 M74 147 78 153 M105 159 110 165 M129 170 133 175 M190 186 198 183 M284 160 291 158 M347 144 354 142" opacity=".3" />
  </svg>
);